import { psnLogin, psnApi, psnSave } from "@/api/niceTax";
import axios from "axios";

//세션에 저장
const psnStore = {
    namespaced: true,
    state: {
        cvarBsno: "",
        agentBsno: "",
        loginOrgCd: "",
        resNm: "",
        resNo: "",
        mobileCo: "",
        mobileNo: "",

        stepData: "",
        cookieData: "",

        // 홈택스 사업자증명 스크래핑 리턴값 정제, 타 증명서 스크래핑시 필요한 정보
        psnInfo: {},

        rprsResno: "",
    },
    getters: {
        // 간편인증용 파라미터
        cvarBsno(state) {
            return state.cvarBsno;
        },
        agentBsno(state) {
            return state.agentBsno;
        },
        loginOrgCd(state) {
            return state.loginOrgCd;
        },
        resNm(state) {
            return state.resNm;
        },
        resNo(state) {
            return state.resNo;
        },
        mobileCo(state) {
            return state.mobileCo;
        },
        mobileNo(state) {
            return state.mobileNo;
        },

        // 간편인증으로 받아오는 파라미터
        stepData(state) {
            return state.stepData;
        },
        cookieData(state) {
            return state.cookieData;
        },

        //사업자증명으로 받아오는 파라미터
        rprsResno(state) {
            return state.rprsResno;
        }
    },

    mutations: {
        SET_BIZ_NO(state, bizNo) {
            state.cvarBsno = bizNo;
            state.agentBsno = bizNo;
        },
        SET_ORG_CD(state, orgCd) {
            state.loginOrgCd = orgCd;
        },
        SET_LOGIN_PARAMS(state, params) {
            state.resNm = params.resNm;
            state.resNo = params.resNo;
            state.mobileCo = params.mobileCo;
            state.mobileNo = params.mobileNo;
        },
        SET_STEP_DATA(state, stepData) {
            state.stepData = stepData;
        },
        SET_COOKIE_DATA(state, cookieData) {
            state.cookieData = cookieData;
        },
        SET_PSN_INFO(state, psnInfo) {
            state.psnInfo = psnInfo;
        },
        SET_RPRS_RESNO(state, rprsResno) {
            state.rprsResno = rprsResno;
        }
    },

    actions: {
        SET_BIZ_NO({ commit }, bizNo) {
            if (bizNo.length == 16) {
                commit("SET_BIZ_NO", atob(bizNo));
            } else {
                commit("SET_BIZ_NO", bizNo);
            }
        },
        SET_ORG_CD({ commit }, orgCd) {
            commit("SET_ORG_CD", orgCd);
        },
        async PSN_CERTIFICATE({ commit }, params) {
            commit("SET_LOGIN_PARAMS", params);
            const { data } = await psnLogin(params);
            if (data.data) {
                const response = JSON.parse(data.data);
                commit("SET_STEP_DATA", response.out.stepData);
                commit("SET_COOKIE_DATA", response.out.cookieData);
            }
        },
        /**
         * 개인인증용 스크래핑 & 데이터 세션 저장
         */
        async SCRAP_AND_SET_DATA_PSN({ commit }, params) {
            // 요청값 스토어 저장
            commit("sendStore/ADD_SCRAP_REQUEST", { [params.code]: params.inJson }, { root: true });

            // 스크래핑
            const scrapData = {};
            try {
                if (process.env.NODE_ENV === 'production') {
                    const { data } = await psnApi(params.inJson);
                    const jsonData = JSON.parse(data.data);
                    
                    //스크래핑시 마다 cookieData 받아온 값으로 변경처리(홈택스 로그인 유지)
                    commit("SET_COOKIE_DATA", jsonData.out.cookieData);
                    
                    if (jsonData.resCd != "0000") {
                        scrapData.error = `[${jsonData.resCd}]${jsonData.resMsg}`;
                    } else {
                        scrapData.data = JSON.stringify(jsonData.out);
                    }
                } else {
                    //로컬 테스트시 
                    const { data } = await axios.get(`/api_logs/psn/${params.code}_res.json`);
                    scrapData.data = JSON.stringify(data);
                }
            } catch (error) {
                console.error(error);
                scrapData.error = error.message;
            }

            // 스크래핑 결과값 스토어 저장
            await commit("sendStore/ADD_SCRAP_DATA", { [params.code]: scrapData }, { root: true });
        },

        async SEND_SCRAP_DATA_AND_GET_RESULT_PSN({ commit, state, rootState }) {
            const param = {
                scrapRequest: rootState.sendStore.scrapRequest,
                scrapData: rootState.sendStore.scrapData,
                psnInfo: state.psnInfo,
            };
            const { data } = await psnSave(param);
            commit("sendStore/SET_SCRAP_RESULT", data.data, { root: true });
        },

        SAVE_PSN_INFO({ commit, state }, data) {
            commit("SET_PSN_INFO", {
                cvarBsno: state.cvarBsno,
                aplcTnm: data.bmanBscInfrInqrDVO.txprNm,
                rprsTxprNm: data.bmanBscInfrInqrDVO.rprsTxprNm,
                rprsResno: data.bmanBscInfrInqrDVO.rprsResno,
                telNo: state.mobileNo,
                agentBsno: state.agentBsno,  //전송자 사업자번호
                agentNm: data.bmanBscInfrInqrDVO.txprNm,      //전송자 기업명 혹은 대표자명
                agntUserNm: state.resNm,
                agntUserTelno: state.mobileNo,
                certGb: "간편인증",
                rcvOgz: "나이스디앤비"
            });
        },

    }
}

export default psnStore; 
